import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
// import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
import { PATH_AFTER_SIGNUP } from '../config-global';
//
import {
  // Auth
  LoginPage,
  ForgotPasswordForm,
  ChangePassword,
  // Dashboard: General
  GeneralAppPage,
  GeneralFilePage,
  GeneralBankingPage,
  GeneralEcommercePage,
  GeneralAnalyticsPage,
  BookingListPage,
  // Dashboard: User
  UserListPage,
  UserEditPage,
  UserCardsPage,
  UserCreatePage,
  UserProfilePage,
  UserAccountPage,
  // Dashboard: Profile
  UpdateProfilePage,
  UpdateSetting,
  UpdateUploadSettingPage,
  InvoiceDetailsPage,
  InvoiceStovkInDetailsPage,
  // Dashboard: FileManager
  FileManagerPage,
  // Dashboard: App
  ChatPage,
  MailPage,
  CalendarPage,
  KanbanPage,
  //
  BlankPage,
  PermissionDeniedPage,
  //
  Page500,
  Page403,
  Page404,
  // HomePage,
  FaqsPage,
  AboutPage,
  Contact,
  PricingPage,
  ComingSoonPage,
  MaintenancePage,
  //
  ComponentsOverviewPage,
  FoundationColorsPage,
  FoundationTypographyPage,
  FoundationShadowsPage,
  FoundationGridPage,
  FoundationIconsPage,
  //
  MUIAccordionPage,
  MUIAlertPage,
  MUIAutocompletePage,
  MUIAvatarPage,
  MUIBadgePage,
  MUIBreadcrumbsPage,
  MUIButtonsPage,
  MUICheckboxPage,
  MUIChipPage,
  MUIDataGridPage,
  MUIDialogPage,
  MUIListPage,
  MUIMenuPage,
  MUIPaginationPage,
  MUIPickersPage,
  MUIPopoverPage,
  MUIProgressPage,
  MUIRadioButtonsPage,
  MUIRatingPage,
  MUISliderPage,
  MUIStepperPage,
  MUISwitchPage,
  MUITablePage,
  MUITabsPage,
  MUITextFieldPage,
  MUITimelinePage,
  MUITooltipPage,
  MUITransferListPage,
  // MUITreesViewPage,
  //
  DemoAnimatePage,
  DemoCarouselsPage,
  DemoChartsPage,
  DemoCopyToClipboardPage,
  DemoEditorPage,
  DemoFormValidationPage,
  DemoImagePage,
  DemoLabelPage,
  DemoLightboxPage,
  DemoMapPage,
  DemoMegaMenuPage,
  DemoMultiLanguagePage,
  DemoNavigationBarPage,
  DemoOrganizationalChartPage,
  DemoScrollbarPage,
  DemoSnackbarPage,
  DemoTextMaxLinePage,
  DemoUploadPage,
  DemoMarkdownPage,
  SignUpPage,
  CustomerCreatePage,
  CustomerListPage,
  CustomerEditPage,
  ProductmetaCreatePage,
  ProductmetaListPage,
  ProductmetaEditPage,
  StockInCreatePage,
  StockInListPage,
  StockInCreatePagenew,
  StockInListPagenew,
  StockInEditPage,
  StockOutCreatePage,
  StockOutListPage,
  StockOutCreatePagenew,
  StockOutListPagenew,
  StockOutEditPage,
  SalesRecords,
  StockOutListPage1,
  InvoiceFinalDetailsPage,
  ViewNewpaymentListPage,
  NewDetailbillListPage,
  GenerateInvoiceListPage,
  InvoiceFinalDetailsPagenew,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
          children: [{ element: <Navigate to={PATH_AFTER_SIGNUP} replace />, index: true }],
        },
        {
          path: 'sign-up',
          element: (
            <GuestGuard>
              <SignUpPage />
            </GuestGuard>
          ),
        },
        { path: 'login-unprotected', element: <LoginPage /> },
        { path: 'forgot-password', element: <ForgotPasswordForm /> },
        { path: 'changePassword', element: <ChangePassword /> },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralAppPage /> },
        { path: 'ecommerce', element: <GeneralEcommercePage /> },
        { path: 'analytics', element: <GeneralAnalyticsPage /> },
        { path: 'booking', element: <BookingListPage /> },
        { path: 'banking', element: <GeneralBankingPage /> },
        { path: 'file', element: <GeneralFilePage /> },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/list" replace />, index: true },
            { path: 'profile', element: <UserProfilePage /> },
            { path: 'cards', element: <UserCardsPage /> },
            { path: 'list', element: <UserListPage /> },
            { path: 'new', element: <UserCreatePage /> },
            { path: ':name/edit', element: <UserEditPage /> },
            { path: 'account', element: <UserAccountPage /> },
          ],
        },
        // UPDATE
        // Profile
        {
          path: 'profile',
          children: [{ path: 'new', element: <UpdateProfilePage /> }],
        },
        // setting
        {
          path: 'setting',
          children: [{ path: 'new', element: <UpdateSetting /> }],
        },
        {
          path: 'uploadSetting',
          children: [{ path: 'new', element: <UpdateUploadSettingPage /> }],
        },
        // cruds
        {
          path: 'sales',
          element: <SalesRecords />,
        },
        {
          path: 'customer',
          children: [
            { path: 'new', element: <CustomerCreatePage /> },
            { path: 'list', element: <CustomerListPage /> },
            { path: ':name/edit', element: <CustomerEditPage /> },
          ],
        },
        {
          path: 'invoice',
          children: [
            {
              element: (
                <Navigate to="/dashboard/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5" replace />
              ),
              index: true,
            },
            { path: 'details', element: <InvoiceDetailsPage /> },
            { path: 'stockin', element: <InvoiceStovkInDetailsPage /> },
            { path: 'final', element: <InvoiceFinalDetailsPage /> },
            { path: 'finalnew', element: <InvoiceFinalDetailsPagenew /> },
          ],
        },
        {
          path: 'productmeta',
          children: [
            { path: 'new', element: <ProductmetaCreatePage /> },
            { path: 'list', element: <ProductmetaListPage /> },
            { path: ':name/edit', element: <ProductmetaEditPage /> },
          ],
        },
        {
          path: 'stockin',
          children: [
            { path: 'new', element: <StockInCreatePage /> },
            { path: 'list', element: <StockInListPage /> },
            { path: ':name/edit', element: <StockInEditPage /> },
          ],
        },
        {
          path: 'stockinnew',
          children: [
            { path: 'new', element: <StockInCreatePagenew /> },
            { path: 'list', element: <StockInListPagenew /> },
            // { path: ':name/edit', element: <StockInEditPage /> },
          ],
        },
        {
          path: 'stockout',
          children: [
            { path: 'new', element: <StockOutCreatePage /> },
            { path: 'list', element: <StockOutListPage /> },
            { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },
        {
          path: 'stockoutnew',
          children: [
            { path: 'new', element: <StockOutCreatePagenew /> },
            { path: 'list', element: <StockOutListPagenew /> },
            // { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },
        {
          path: 'stockout1',
          children: [
            // { path: 'new', element: <StockOutCreatePage /> },
            { path: 'list', element: <StockOutListPage1 /> },
            // { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },
        {
          path: 'newpayment',
          children: [
            // { path: 'new', element: <StockOutCreatePage /> },
            { path: 'list', element: <ViewNewpaymentListPage /> },
            // { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },
        {
          path: 'newdetailbill',
          children: [
            // { path: 'new', element: <StockOutCreatePage /> },
            { path: 'list', element: <NewDetailbillListPage /> },
            // { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },
  {
          path: 'generateinvoice',
          children: [
            // { path: 'new', element: <StockOutCreatePage /> },
            { path: 'list', element: <GenerateInvoiceListPage /> },
            // { path: ':name/edit', element: <StockOutEditPage /> },
          ],
        },


        {
          path: 'billing',
          children: [
            { element: <Navigate to="/dashboard/billing/list" replace />, index: true },
            { path: 'profile', element: <UserProfilePage /> },
            { path: 'cards', element: <UserCardsPage /> },
            // { path: 'list', element: <TopupListPage /> },
            // { path: 'new', element: <TopupCreatePage /> },
            { path: ':name/edit', element: <UserEditPage /> },
            { path: 'account', element: <UserAccountPage /> },
          ],
        },

        {
          path: 'blog',
          children: [{ element: <Navigate to="/dashboard/blog/posts" replace />, index: true }],
        },
        { path: 'files-manager', element: <FileManagerPage /> },
        {
          path: 'mail',
          children: [
            { element: <Navigate to="/dashboard/mail/all" replace />, index: true },
            { path: 'label/:customLabel', element: <MailPage /> },
            { path: 'label/:customLabel/:mailId', element: <MailPage /> },
            { path: ':systemLabel', element: <MailPage /> },
            { path: ':systemLabel/:mailId', element: <MailPage /> },
          ],
        },
        {
          path: 'chat',
          children: [
            { element: <ChatPage />, index: true },
            { path: 'new', element: <ChatPage /> },
            { path: ':conversationKey', element: <ChatPage /> },
          ],
        },
        { path: 'calendar', element: <CalendarPage /> },
        { path: 'kanban', element: <KanbanPage /> },
        { path: 'permission-denied', element: <PermissionDeniedPage /> },
        { path: 'blank', element: <BlankPage /> },
      ],
    },

    // Main Routes
    {
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'about-us', element: <AboutPage /> },
        { path: 'contact-us', element: <Contact /> },
        { path: 'faqs', element: <FaqsPage /> },
        // Demo Components
        {
          path: 'components',
          children: [
            { element: <ComponentsOverviewPage />, index: true },
            {
              path: 'foundation',
              children: [
                { element: <Navigate to="/components/foundation/colors" replace />, index: true },
                { path: 'colors', element: <FoundationColorsPage /> },
                { path: 'typography', element: <FoundationTypographyPage /> },
                { path: 'shadows', element: <FoundationShadowsPage /> },
                { path: 'grid', element: <FoundationGridPage /> },
                { path: 'icons', element: <FoundationIconsPage /> },
              ],
            },
            {
              path: 'mui',
              children: [
                { element: <Navigate to="/components/mui/accordion" replace />, index: true },
                { path: 'accordion', element: <MUIAccordionPage /> },
                { path: 'alert', element: <MUIAlertPage /> },
                { path: 'autocomplete', element: <MUIAutocompletePage /> },
                { path: 'avatar', element: <MUIAvatarPage /> },
                { path: 'badge', element: <MUIBadgePage /> },
                { path: 'breadcrumbs', element: <MUIBreadcrumbsPage /> },
                { path: 'buttons', element: <MUIButtonsPage /> },
                { path: 'checkbox', element: <MUICheckboxPage /> },
                { path: 'chip', element: <MUIChipPage /> },
                { path: 'data-grid', element: <MUIDataGridPage /> },
                { path: 'dialog', element: <MUIDialogPage /> },
                { path: 'list', element: <MUIListPage /> },
                { path: 'menu', element: <MUIMenuPage /> },
                { path: 'pagination', element: <MUIPaginationPage /> },
                { path: 'pickers', element: <MUIPickersPage /> },
                { path: 'popover', element: <MUIPopoverPage /> },
                { path: 'progress', element: <MUIProgressPage /> },
                { path: 'radio-button', element: <MUIRadioButtonsPage /> },
                { path: 'rating', element: <MUIRatingPage /> },
                { path: 'slider', element: <MUISliderPage /> },
                { path: 'stepper', element: <MUIStepperPage /> },
                { path: 'switch', element: <MUISwitchPage /> },
                { path: 'table', element: <MUITablePage /> },
                { path: 'tabs', element: <MUITabsPage /> },
                { path: 'textfield', element: <MUITextFieldPage /> },
                { path: 'timeline', element: <MUITimelinePage /> },
                { path: 'tooltip', element: <MUITooltipPage /> },
                { path: 'transfer-list', element: <MUITransferListPage /> },
                // { path: 'tree-view', element: <MUITreesViewPage /> },
              ],
            },
            {
              path: 'extra',
              children: [
                { element: <Navigate to="/components/extra/animate" replace />, index: true },
                { path: 'animate', element: <DemoAnimatePage /> },
                { path: 'carousel', element: <DemoCarouselsPage /> },
                { path: 'chart', element: <DemoChartsPage /> },
                { path: 'copy-to-clipboard', element: <DemoCopyToClipboardPage /> },
                { path: 'editor', element: <DemoEditorPage /> },
                { path: 'form-validation', element: <DemoFormValidationPage /> },
                { path: 'image', element: <DemoImagePage /> },
                { path: 'label', element: <DemoLabelPage /> },
                { path: 'lightbox', element: <DemoLightboxPage /> },
                { path: 'map', element: <DemoMapPage /> },
                { path: 'mega-menu', element: <DemoMegaMenuPage /> },
                { path: 'multi-language', element: <DemoMultiLanguagePage /> },
                { path: 'navigation-bar', element: <DemoNavigationBarPage /> },
                { path: 'organization-chart', element: <DemoOrganizationalChartPage /> },
                { path: 'scroll', element: <DemoScrollbarPage /> },
                { path: 'snackbar', element: <DemoSnackbarPage /> },
                { path: 'text-max-line', element: <DemoTextMaxLinePage /> },
                { path: 'upload', element: <DemoUploadPage /> },
                { path: 'markdown', element: <DemoMarkdownPage /> },
              ],
            },
          ],
        },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [{ path: 'pricing', element: <PricingPage /> }],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
